export function parseLocationCodes(str = "") {
  const codes = [];
  let i = 0;
  while (i < str.length) {
    const third = str.charAt(i + 2);
    if (third && /\d/.test(third)) {
      // 3-char code: two letters + digit
      codes.push(str.substr(i, 3));
      i += 3;
    } else {
      // 2-char code: two letters
      codes.push(str.substr(i, 2));
      i += 2;
    }
  }
  return codes;
}